export const OrderCreditState = Object.freeze({
  CONCEPT: 0,
  VALID: 1,
});
